import { useEffect, useState } from 'react'

/**
 * True while a window is open over the page: dialog, side panel, alert, menu
 * or list. Radix marks the body (`data-scroll-locked`) for every modal one and
 * mounts each window in its own child of the body, so watching the body alone
 * is enough, without listing the windows of the app one by one.
 */
function windowOpen(): boolean {
  if (document.body.hasAttribute('data-scroll-locked')) return true
  return Boolean(document.querySelector('[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]'))
}

export function useWindowOpen(): boolean {
  const [open, setOpen] = useState(() => typeof document !== 'undefined' && windowOpen())
  useEffect(() => {
    const update = () => setOpen(windowOpen())
    const observer = new MutationObserver(update)
    observer.observe(document.body, { childList: true, attributes: true, attributeFilter: ['data-scroll-locked'] })
    update()
    return () => observer.disconnect()
  }, [])
  return open
}
